import { BroadcastService, FLETCHERS_CHANNEL } from '@/broadcast';

export const useFletchersBroadcast = <T>() => {
  const broadcastService = BroadcastService.getInstance(FLETCHERS_CHANNEL);

  const sendMessageWithoutResponse = (eventName: string, payload: T) => {
    broadcastService.sendMessageWithoutResponse(FLETCHERS_CHANNEL, eventName, payload);
  };

  /**
   * //** How to send and wait
   *
   * sendMessageWithResponse('PING', {})
   *   .then((response) => {
   *     console.log('Pong response:', response);
   *   });
   *
   *
   * //** How to receive and answer
   *
   * window.addEventListener(PING, (event: CustomEvent) => {
   *   const { payload, reply } = event.detail;
   *   console.log('Ping received:', payload);
   *
   *   //** Send response
   *   reply({ pong: true });
   * });
   *
   */
  const sendMessageWithResponse = <R = unknown>(eventName: string, payload: T, timeoutMs?: number): Promise<R> => {
    return broadcastService.sendMessageWithResponse<T, R>(FLETCHERS_CHANNEL, eventName, payload, timeoutMs);
  };

  return {
    sendMessageWithoutResponse,
    sendMessageWithResponse
  };
};
